<template>
	<div class="info">
		<div>
			<InformationIcon />
		</div>
		<transition name="tooltip">
			<div class="info-box">
				<div class="info-text">
                    {{ informationText }}
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import InformationIcon from '@/components/shared/Icons/InformationIcon.vue';

export default {
	name: 'InfoTooltip',
	components: {
		InformationIcon,
	},
    props: {
        informationText: {
            required: true,
        },
    },
	data: () => ({}),
	mounted() {},
	methods: {},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'InfoTooltip.scss';
</style>
